import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationCustomerCommentsPluginService } from './customer-comments.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
    selector: 'installation-customer-comments-edit',
    templateUrl: './customer-comments-edit.component.html',
    standalone: false
})
export class InstallationCustomerCommentsEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;

  public commentFromTargets: any[];
  public currentItem: any;

  private valueToRemove: number;
  private sub = new Subscription();

  @ViewChild('commentFromTargetsModal', { static: true }) commentFromTargetsModal: ModalComponent;
  @ViewChild('valueDeleteConfirm', { static: true }) valueDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected cdRef: ChangeDetectorRef,
    location: Location,
    protected pluginService: InstallationCustomerCommentsPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['comments'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateComments(this.inspectionId, this.pointId, this.pluginId, model.comments)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['comments'];
    control.push(this.initArrayValue());
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['comments'];
    control.removeAt(this.valueToRemove);
  }

  public onClose(e: any) {
    this.currentItem.controls['From'].markAsTouched();
  }

  public selectCommentFromTargetsMenu(item: any) {
    const selectedIndex = this.currentItem.controls['From'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['From'].setValue(selectedIndex);
  }

  public openFromSelector(selectedIndex: number, i: number): void {
    this.openSelector(
      this.commentFromTargetsModal,
      this.commentFromTargets,
      selectedIndex || selectedIndex === 0 ? selectedIndex : -1
    );
    const control = <UntypedFormArray>this.editForm.controls['comments'];
    this.currentItem = control.controls[i];
  }

  public openValueDeleteConfirm(i: number) {
    this.valueDeleteConfirm.open();
    this.valueToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.commentFromTargets = _.orderBy(this.pluginService.getCommentFromTargets(), ['label']);
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      comments: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['comments'];
    _.forEach(this.plugin.config.Comments, (el) => {
      control.push(this.initArrayValue(el));
    });
  }

  private initArrayValue(el?: any) {
    const regex = new RegExp(/<br\s*[\/]?>/gi);
    return this.fb.group({
      From: new UntypedFormControl(el && el.From ? parseInt(el.From) : 0),
      Comment: new UntypedFormControl(el?.Comment ? el.Comment.replace(regex, '\n') : '')
    });
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '20rem',
    minHeight: '5rem',
    width: '100%',
    placeholder: 'Insert your comments here',
    translate: 'no',
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'heading',
        'fontName',
        'fontSize',
        'textColor',
        'backgroundColor',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };
}
